module.exports = __webpack_public_path__ + "img/Show-pic.16db91a4.png";